import {lazy} from "react";
import {Route, Switch} from "react-router-dom";
import Main from "./pages/Main";
import MainCertificatesPage from "./pages/Main/Certificates";
import PublicLanding from "./pages/Main/PublicLanding";
import Registration from "./pages/Registration";
import Login from "./pages/Login";
import RestorePasswordPage from "./pages/RestorePassword";
import ChangePasswordByHashPage from "./pages/RestorePassword/ChangeByHash";
import ChangePasswordByPhonePage from "./pages/RestorePassword/ChangeByPhone";
import SurveyList from "./pages/Surveys/List";
import SurveyItemPage from "./pages/Surveys/Item";
import OrganizationsList from "./pages/Organizations/List";
import OrganizationView from "./pages/Organizations/View";
import EventsPage from "./pages/Events/EventsPage";
import EventPage from "./pages/Events/Event";
import EventRegistrationPage from "./pages/Events/Registration";
import TagManager from 'react-gtm-module'
import PortfolioPage from "./pages/Portfolio/Portfolio";
import GuardedRoute from "./components/Route/GuardedRoute";
import ProfileCompletePage from "./pages/Profile/Complete/ProfileCompletePage";
import InactivePage from "./pages/Inactive";
import InactiveSocialPage from "./pages/Inactive/Social";
import LibraryList from "./pages/Library/List";
import LibrarySection from "./pages/Library/Section";
import LibraryMaterial from "./pages/Library/Material";
import PromoCodesListPage from "./pages/PromoCodes/List";
import ActivatePromoCodePage from "./pages/PromoCodes/Activate";
import ProfileSummaryPage from "./pages/Profile/Summary";
import ProfileReferralsPage from "./pages/Profile/Referrals";
import CoursesListPage from "./pages/Courses/List";
import MyCoursesListPage from "./pages/Courses/My";
import FinishedCoursesListPage from "./pages/Courses/Finished";
import CoursePreviewPage from "./pages/Courses/Preview";
import CoursePage from "./pages/Courses/Course";
import CourseCertificatePage from "./pages/Courses/Certificate";
import TestingsListPage from "./pages/Testings/List";
import MyTestingsListPage from "./pages/Testings/My";
import FinishedTestingsListPage from "./pages/Testings/Finished";
import TestingPreviewPage from "./pages/Testings/Preview";
import TestingPage from "./pages/Testings/Testing";
import AboutPage from "./pages/About";
import InstructionPage from "./pages/Instruction";
import PaymentDescriptionPage from "./pages/Payment/Description";
import PaymentCashBackPage from "./pages/Payment/CashBack";
import PaymentDataProtectionPage from "./pages/Payment/DataProtection";
import MaterialPaymentPage from "./pages/Payment/Material";
import CoursePaymentPage from "./pages/Payment/Course";
import ConferencePaymentPage from "./pages/Payment/Conference";
import NotFoundPage from "./pages/Errors/NotFound";
import ServerErrorPage from "./pages/Errors/ServerError";
import SearchPage from "./pages/Search";
import CertificationsListPage from "./pages/Certifications/List";
import CertificationEditPage from "./pages/Certifications/Edit";
import ConferenceTicketViewPage from "./pages/Events/TicketView";

const ProfileEditPage = lazy(() => import("./pages/Profile/Edit"));

const gtmId = process.env.REACT_APP_GTM_ID;
if (gtmId) {
    TagManager.initialize({gtmId});
}

export default function Routes() {
    const bootstrapErrorStatus = typeof window !== 'undefined'
        ? Number(window.__SPA_ERROR_STATUS__ || 0)
        : 0;

    if (typeof window !== 'undefined' && window.__SPA_ERROR_STATUS__) {
        delete window.__SPA_ERROR_STATUS__;
    }

    if (bootstrapErrorStatus === 500) {
        return <ServerErrorPage />;
    }

    if (bootstrapErrorStatus === 404) {
        return <NotFoundPage />;
    }

    return (
        <Switch>
            <GuardedRoute exact path="/" guestOnly guestRedirectPath="/main" profileFillRequired={false}>
                <PublicLanding />
            </GuardedRoute>
            <GuardedRoute exact path="/main/certificates" authRequired profileFillRequired={false}>
                <MainCertificatesPage />
            </GuardedRoute>
            <GuardedRoute exact path="/main" authRequired profileFillRequired={false}>
                <Main />
            </GuardedRoute>
            <GuardedRoute exact path="/about">
                <AboutPage />
            </GuardedRoute>
            <GuardedRoute exact path="/instruction">
                <InstructionPage />
            </GuardedRoute>
            <GuardedRoute exact path="/instructions">
                <InstructionPage />
            </GuardedRoute>
            <GuardedRoute exact path="/search" profileFillRequired={false}>
                <SearchPage />
            </GuardedRoute>
            <GuardedRoute exact path="/payment">
                <PaymentDescriptionPage />
            </GuardedRoute>
            <GuardedRoute exact path="/payment/cashBack" authRequired>
                <PaymentCashBackPage />
            </GuardedRoute>
            <GuardedRoute exact path="/payment/cashback" authRequired>
                <PaymentCashBackPage />
            </GuardedRoute>
            <GuardedRoute exact path="/payment/dataProtection" authRequired>
                <PaymentDataProtectionPage />
            </GuardedRoute>
            <GuardedRoute exact path="/payment/data-protection" authRequired>
                <PaymentDataProtectionPage />
            </GuardedRoute>
            <GuardedRoute exact path="/payment/material/:id" authRequired>
                <MaterialPaymentPage />
            </GuardedRoute>
            <GuardedRoute exact path="/payment/course/:id" authRequired>
                <CoursePaymentPage />
            </GuardedRoute>
            <GuardedRoute exact path="/payment/conferences/:ticketId" authRequired>
                <ConferencePaymentPage />
            </GuardedRoute>
            <Route exact path="/404">
                <NotFoundPage />
            </Route>
            <Route exact path="/500">
                <ServerErrorPage />
            </Route>
            <GuardedRoute exact path="/account/registration" guestOnly>
                <Registration />
            </GuardedRoute>
            <GuardedRoute exact path="/account/registration/pharm" guestOnly>
                <Registration />
            </GuardedRoute>
            <GuardedRoute exact path="/account/login" guestOnly>
                <Login />
            </GuardedRoute>
            <GuardedRoute exact path="/account/restore-password">
                <RestorePasswordPage />
            </GuardedRoute>
            <GuardedRoute exact path="/account/change-password">
                <ChangePasswordByHashPage />
            </GuardedRoute>
            <GuardedRoute exact path="/account/change-password/phone">
                <ChangePasswordByPhonePage />
            </GuardedRoute>
            <GuardedRoute exact path="/inactive" authRequired profileFillRequired={false}>
                <InactivePage />
            </GuardedRoute>
            <GuardedRoute exact path="/inactiveSocial" authRequired profileFillRequired={false}>
                <InactiveSocialPage />
            </GuardedRoute>
            <GuardedRoute exact path="/surveys/finished">
                <SurveyList />
            </GuardedRoute>
            <GuardedRoute exact path="/surveys/:id">
                <SurveyItemPage />
            </GuardedRoute>
            <GuardedRoute path="/surveys">
                <SurveyList />
            </GuardedRoute>
            <GuardedRoute exact path="/organizations">
                <OrganizationsList />
            </GuardedRoute>
            <GuardedRoute exact path="/organization/:urlSlug/:tab?">
                <OrganizationView />
            </GuardedRoute>
            <GuardedRoute exact path="/library">
                <LibraryList />
            </GuardedRoute>
            <GuardedRoute exact path="/library/:id/:page?">
                <LibrarySection />
            </GuardedRoute>
            <GuardedRoute exact path="/material/chargeable/:sectionId/:id">
                <LibraryMaterial />
            </GuardedRoute>
            <GuardedRoute exact path="/material/:sectionId/:id">
                <LibraryMaterial />
            </GuardedRoute>
            <GuardedRoute exact path="/material/:id">
                <LibraryMaterial />
            </GuardedRoute>
            <GuardedRoute exact path="/promoCodes" authRequired>
                <PromoCodesListPage />
            </GuardedRoute>
            <GuardedRoute exact path="/activatePromoCode" authRequired>
                <ActivatePromoCodePage />
            </GuardedRoute>
            <GuardedRoute exact path="/profile" authRequired>
                <ProfileSummaryPage />
            </GuardedRoute>
            <GuardedRoute exact path="/profile/edit" authRequired>
                <ProfileEditPage />
            </GuardedRoute>
            <GuardedRoute exact path="/profile/referrals" authRequired>
                <ProfileReferralsPage />
            </GuardedRoute>
            <GuardedRoute exact path="/certifications" authRequired profileFillRequired={false}>
                <CertificationsListPage />
            </GuardedRoute>
            <GuardedRoute exact path="/certifications/:id" authRequired profileFillRequired={false}>
                <CertificationEditPage />
            </GuardedRoute>
            <GuardedRoute exact path="/courses">
                <CoursesListPage />
            </GuardedRoute>
            <GuardedRoute exact path="/mycourses" authRequired>
                <MyCoursesListPage />
            </GuardedRoute>
            <GuardedRoute exact path="/finished-courses" authRequired>
                <FinishedCoursesListPage />
            </GuardedRoute>
            <GuardedRoute exact path="/course/preview/:id">
                <CoursePreviewPage />
            </GuardedRoute>
            <GuardedRoute exact path="/course/:id" authRequired>
                <CoursePage />
            </GuardedRoute>
            <GuardedRoute exact path="/course/:id/certificate" authRequired>
                <CourseCertificatePage />
            </GuardedRoute>
            <GuardedRoute exact path="/testings" authRequired>
                <TestingsListPage />
            </GuardedRoute>
            <GuardedRoute exact path="/my-testings" authRequired>
                <MyTestingsListPage />
            </GuardedRoute>
            <GuardedRoute exact path="/finished-testings" authRequired>
                <FinishedTestingsListPage />
            </GuardedRoute>
            <GuardedRoute exact path="/testings/preview/:id" authRequired>
                <TestingPreviewPage />
            </GuardedRoute>
            <GuardedRoute exact path="/testings/:id" authRequired>
                <TestingPage />
            </GuardedRoute>
            <GuardedRoute path="/conferences">
                <EventsPage />
            </GuardedRoute>
            <GuardedRoute authRequired path="/portfolio">
                <PortfolioPage />
            </GuardedRoute>
            <GuardedRoute exact path="/conference/:id/registration" authRequired profileFillRequired={false}>
                <EventRegistrationPage />
            </GuardedRoute>
            <GuardedRoute exact path="/conference/:id/tickets/:ticketId" authRequired profileFillRequired={false}>
                <ConferenceTicketViewPage />
            </GuardedRoute>
            <GuardedRoute
                path={`/conference/:id`}
            >
                <EventPage />
            </GuardedRoute>
            <GuardedRoute
                path="/profile/complete"
                authRequired
                profileFillRequired={false}
            >
                <ProfileCompletePage />
            </GuardedRoute>
            <Route path="*">
                <NotFoundPage />
            </Route>
        </Switch>
    )
}
